<template>
  <div>
    <b-img
      :src="source"
      :alt="alt"
      @error="imageLoadError"
      fluid-grow
    ></b-img>
  </div>
</template>


<script>
export default {
  name: "picture-fallback",
  props: {
    picture: Object,
    src: String,
    alt: String,
    type: {
      type: String,
      default: "product",
    },
  },
  data () {
    return {
      fallbacks: {
        product: require("@/static/fallback_drug_picture.png"),
        pharmacy: require("@/static/fallback_insurance_logo.png"),
        pharmacy_header: require("@/static/fallback_insurance_header.png"),
        carrier: require("@/static/fallback_carrier_logo.png"),
      },
    };
  },
  computed: {
    fallback () {
      return this.fallbacks[this.type];
    },
    source () {
      if (this.picture) {
        return this.picture.picture || this.fallback;
      }
      return this.src || this.fallback;
    },
  },
  methods: {
    imageLoadError(evt) {
      evt.srcElement.src = this.fallback;
    },
  },
};
</script>
